import React from 'react';

export default function XMarkIcon(props: React.SVGAttributes<SVGSVGElement>) {
	return (
		<svg width='20' height='20' viewBox='0 0 24 24' {...props}>
			<path
				fill='currentColor'
				d='M18.4 4L12 10.4L5.6 4L4 5.6L10.4 12L4 18.4L5.6 20L12 13.6L18.4 20L20 18.4L13.6 12L20 5.6L18.4 4Z'
			></path>
		</svg>
	);
}
